import type { ReactNode } from "react";

import useTranslations from "@/shared/lang/useTranslations";

export interface PaymentsActivityHeaderProps {
  /** Live caption + refresh control, right-aligned. */
  actions?: ReactNode;
}

/**
 * Page header for the payments activity monitor. Mirrors `CardsHeader`, plus the mono eyebrow `WalletsHeader`
 * uses — this screen is a live monitor and the eyebrow is where that reads before the numbers do.
 */
export function PaymentsActivityHeader({ actions }: PaymentsActivityHeaderProps) {
  const { t } = useTranslations("paymentsActivity");

  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0">
        <p className="mb-1 font-mono text-[11px] uppercase tracking-wider text-muted-foreground">
          {t("page_eyebrow")}
        </p>
        <h1 className="truncate text-2xl font-semibold leading-tight tracking-tight text-foreground">
          {t("page_title")}
        </h1>
        <p className="mt-1 truncate text-sm text-muted-foreground">{t("page_subtitle")}</p>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
